import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDollarCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.67188 14.8298C8.67188 16.1198 9.66188 17.1598 10.8919 17.1598H13.4019C14.4719 17.1598 15.3419 16.2498 15.3419 15.1298C15.3419 13.9098 14.8119 13.4798 14.0219 13.1998L9.99187 11.7998C9.20187 11.5198 8.67188 11.0898 8.67188 9.86984C8.67188 8.74984 9.54187 7.83984 10.6119 7.83984H13.1219C14.3519 7.83984 15.3419 8.87984 15.3419 10.1698",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6.5V18.5",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDollarCircle;
